import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
const ColdPackContent = dynamic(() => import('./main'), {
  ssr: false,
  loading: () => <Skeleton />
});
const Skeleton = () => {
  return (
    <div className="mt-4 flex items-end box-border" style={{ height: 32.8 }}>
      <div className="skeleton h-4 w-1/4 mr-3 rounded-full"></div>
      <div className="skeleton h-4 w-1/4"></div>
    </div>
  );
};
function ColdPack(props: any) {
  const { ref: viewRef, show } = useLazyData(
    {
      threshold: 0.01,
      rootMargin: '15px 0px 0px 0px'
    },
    props.showSkeleton || false
  );
  if (!show)
    return (
      <div ref={viewRef}>
        <Skeleton />
      </div>
    );
  return <ColdPackContent {...props} />;
}

export default ColdPack;
